import CityPageTemplate from "../city-template/CityPageTemplate";
import { tempeConfig } from "./data";

export default function TempePage() {
  return <CityPageTemplate config={tempeConfig} />;
}